import { memo } from 'react'

import Navigation from './includes/Navigation'
import Promobar from './includes/Promobar'

function WellBeingHeader() {
  return (
    <header>
      <Promobar />
      <Navigation />
    </header>
  )
}

export default memo(WellBeingHeader)
